import { LOGIN_OTP_COUNT, OTP_PATTERN } from "@/shared/common/constants";
import { Notification } from "@/shared/components";
import { Modal } from "@ab.uitools/ui-library/components/Modal";
import { OneTimePassword } from "@ab.uitools/ui-library/components/OneTimePassword";
import { Spinner } from "@ab.uitools/ui-library/components/Spinner";
import type { TextPropTypes } from "@ab.uitools/ui-library/components/Text/types";
import { useTranslation } from "react-i18next";

interface Props extends TextPropTypes {
  isOpen: boolean;
  isLoading?: boolean;
  togglePopup: (isOpen: boolean) => void;
  handleChangeToken: (token: string) => void;
}

export const OTPPopup = (
  {
    isOpen = false,
    isLoading = false,
    togglePopup,
    handleChangeToken,
  }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => togglePopup(false)}
      onSubmit={() => undefined}
      titleProps={{
        title: t("signModal.title"),
        size: "large"
      }}
      closeIcon={!isLoading}
      closeOnOutsideClick={!isLoading}
    >
      <>
        <Notification/>
        {isLoading && <Spinner size="small"/>}
        <OneTimePassword
          className="mt-16"
          placeholder="X"
          type="number"
          pattern={OTP_PATTERN}
          disabled={isLoading}
          label={t("signModal.oneTimePassword")}
          count={LOGIN_OTP_COUNT}
          autoFocus
          onInvalid={(e) => e.preventDefault()}
          handleChange={(_, value) => handleChangeToken(value)}
        />
      </>
    </Modal>
  );
};
